// 쿠팡 상세페이지 HTML 변환 유틸리티

const F = 'font-family: Batang, NanumMyeongjo;';
const C = '#169179';
const CR = '#e03e2d';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CW = '#ba372a';
const L = 'line-height: 2.0; margin: 0;';
const LC = 'line-height: 2; margin: 0px; text-align: center;';

function sp(n: number) {
  let s = '';
  for (let i = 0; i < n; i++) s += `<p style="text-align: left;">&nbsp;</p>\n`;
  return s;
}

function spL(n: number) {
  let s = '';
  for (let i = 0; i < n; i++) s += `<p style="text-align: left; ${L}">&nbsp;</p>\n`;
  return s;
}

function esc(s: string) {
  return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function wrapTitle(t: string) { return `<p style="${LC}"><span style="color: ${C}; ${F} font-size: 24pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapSubtitle(t: string) { return `<p style="${LC}"><span style="color: ${C}; ${F} font-size: 14pt;">${esc(t)}</span></p>\n`; }
function wrapHeading(t: string) { return `<p style="text-align: left; ${L}"><span style="${F} color: ${C}; font-size: 24pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapHeadingRed(t: string) { return `<p style="text-align: left; ${L}"><span style="${F} color: ${CR}; font-size: 24pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapSub(t: string) { return `<p style="text-align: left; ${L}"><span style="color: #000000; ${F} font-size: 18pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapText(t: string) { return `<p style="text-align: left; ${L}"><span style="color: #000000; ${F} font-size: 14pt;">${esc(t)}</span></p>\n`; }
// 한 단락 안의 여러 줄을 한 <p> 안의 다중 <span>으로 출력 (참고 HTML 형식과 일치)
function wrapTextMulti(lines: string[]) {
  if (lines.length === 0) return '';
  if (lines.length === 1) return wrapText(lines[0]);
  const spans = lines.map((l, i) => {
    const text = i < lines.length - 1 ? `${l} ` : l;
    return `<span style="color: #000000; ${F} font-size: 14pt;">${esc(text)}</span>`;
  }).join('');
  return `<p style="text-align: left; ${L}">${spans}</p>\n`;
}
function wrapTextBold(t: string) { return `<p style="text-align: left; ${L}"><span style="color: #000000; ${F} font-size: 14pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapTextUnderline(t: string) { return `<p style="text-align: left; ${L}"><span style="text-decoration: underline;"><span style="color: #000000; ${F} font-size: 14pt; text-decoration: underline;"><strong>${esc(t)}</strong></span></span></p>\n`; }
function wrapQuote(t: string) { return `<p style="font-size: 15px; ${LC}"><span style="background-color: #fbeeb8;"><em><span style="color: #000000; ${F} font-size: 14pt; background-color: #fbeeb8;">${esc(t)}</span></em></span></p>\n`; }
function wrapAlert(t: string) { return `<p style="text-align: left; ${L}"><span style="color: ${CR}; ${F} font-size: 14pt;"><strong>${esc(t)}</strong></span></p>\n`; }
function wrapNote(t: string) { return `<p style="text-align: left; ${L}"><span style="color: #7e8c8d; ${F} font-size: 12pt;">${esc(t)}</span></p>\n`; }
function wrapImg() { return `<p style="text-align: left;"><img src="이미지URL을_입력하세요"></p>\n`; }
function wrapHighlight(t: string) { return `<p style="text-align: left; ${L}"><span style="color: #000000; ${F} font-size: 14pt; background-color: #fbeeb8;">${esc(t)}</span></p>\n`; }
function wrapStrike(t: string) { return `<p style="text-align: left; ${L}"><span style="text-decoration: line-through;"><span style="color: #000000; ${F} font-size: 14pt; text-decoration: line-through;">${esc(t)}</span></span></p>\n`; }

function buildTable(rows: string[][]) {
  let h = `<p style="text-align: left; ${L}"><span style="${F} color: ${C}; font-size: 24pt;"><strong>상품 간략 정보</strong></span></p>\n`;
  h += spL(1);
  h += `<table style="border-collapse: collapse; width: 70.7625%; margin-left: auto; margin-right: auto;" border="1">\n<tbody>\n`;
  rows.forEach(r => {
    h += `<tr>\n<td style="width: 41.071%; text-align: center;"><span style="font-size: 12pt; ${F} color: #000000;">${esc(r[0])}</span></td>\n`;
    h += `<td style="width: 58.929%; text-align: center;"><span style="font-size: 12pt; color: #000000; ${F}">${esc(r[1])}</span></td>\n</tr>\n`;
  });
  h += `</tbody>\n</table>\n`;
  return h;
}

const RED_KEYWORDS = ['보내드려요', '보내드릴게요', '고객센터', '문제가'];

export function convertText(raw: string): string {
  if (!raw.trim()) return '';

  const majorBlocks = raw.trim().split(/\n\s*\n\s*\n/);
  let html = '';
  html += `<div style="max-width: 780px; margin: 0 auto;">\n`;

  majorBlocks.forEach((block, blockIdx) => {
    const paragraphs = block.split(/\n\s*\n/).map(p => p.trim()).filter(p => p);

    paragraphs.forEach((para, paraIdx) => {
      const lines = para.split('\n').map(l => l.trim()).filter(l => l && !/^이미지 설명|^사진 설명/.test(l));
      if (!lines.length) return;

      const tableCandidate = lines.filter(l => /^[^:：|]{1,20}\s*[:：|]\s*.+/.test(l));
      if (tableCandidate.length >= 3 && tableCandidate.length >= lines.length * 0.6) {
        html += sp(1);
        const rows = tableCandidate.map(l => {
          const sep = l.includes('：') ? '：' : l.includes('|') ? '|' : ':';
          const idx = l.indexOf(sep);
          return [l.substring(0, idx).trim().replace(/^[-•]\s*/, ''), l.substring(idx + 1).trim()];
        });
        html += buildTable(rows);
        html += sp(1);
        return;
      }

      if (lines.length === 1 && /^\[이미지\]$|^\[img\]$/i.test(lines[0].trim())) {
        html += wrapImg();
        return;
      }

      if (lines.every(l => /이미지 설명|사진 설명/.test(l))) return;

      if (lines.length <= 3 && lines[0].startsWith('"')) {
        lines.forEach(l => { html += wrapQuote(l.replace(/^"|"$/g, '')); });
        html += sp(1);
        return;
      }

      if (lines.every(l => /^[※*▶-]/.test(l))) {
        lines.forEach(l => { html += wrapNote(l); });
        html += sp(1);
        return;
      }

      if (blockIdx === 0 && paraIdx === 0) {
        html += wrapTitle(lines[0]);
        for (let i = 1; i < lines.length; i++) {
          if (lines[i].length <= 40) html += wrapSubtitle(lines[i]);
          else html += wrapText(lines[i]);
        }
        html += sp(1);
        return;
      }

      if (blockIdx === 0 && paraIdx === 1 && lines.length <= 3 && lines.every(l => l.length <= 50)) {
        lines.forEach(l => html += wrapQuote(l.replace(/^"|"$/g, '')));
        html += sp(1);
        return;
      }

      if (paraIdx === 0 && lines.length <= 2 && lines[0].length <= 35) {
        const isRed = RED_KEYWORDS.some(k => lines[0].includes(k));
        html += isRed ? wrapHeadingRed(lines[0]) : wrapHeading(lines[0]);
        if (lines[1] && lines[1].length <= 40) {
          html += wrapSubtitle(lines[1]);
        } else if (lines[1]) {
          html += wrapText(lines[1]);
        }
        return;
      }

      if (lines.length === 1 && lines[0].length <= 30 && !/^[-▶]/.test(lines[0])) {
        html += wrapSub(lines[0]);
        return;
      }

      // 줄별 분류 후 연속 text 줄들은 한 <p>에 다중 <span>으로 묶어 출력 (참고 HTML 형식)
      type Kind = 'note' | 'bold' | 'text' | 'strike' | 'highlight' | 'sub';
      const classified: { kind: Kind; content: string }[] = lines
        .filter(l => !/이미지 설명|사진 설명/.test(l))
        .map(line => {
          if (/^[※*]/.test(line)) return { kind: 'note', content: line };
          if (/^\[.+\]$/.test(line)) return { kind: 'bold', content: line };
          if (/^▶/.test(line)) return { kind: 'bold', content: line };
          if (/^~~.+~~$/.test(line)) return { kind: 'strike', content: line.replace(/^~~|~~$/g, '') };
          if (/^==.+==$/.test(line)) return { kind: 'highlight', content: line.replace(/^==|==$/g, '') };
          if (/^-\s/.test(line)) return { kind: 'text', content: line };
          if (line.length <= 20 && !line.includes('.') && !line.includes(',')) return { kind: 'sub', content: line };
          return { kind: 'text', content: line };
        });
      let i = 0;
      while (i < classified.length) {
        const cur = classified[i];
        if (cur.kind === 'text') {
          const group: string[] = [];
          while (i < classified.length && classified[i].kind === 'text') {
            group.push(classified[i].content);
            i++;
          }
          html += wrapTextMulti(group);
          continue;
        }
        if (cur.kind === 'note') html += wrapNote(cur.content);
        else if (cur.kind === 'bold') html += wrapTextBold(cur.content);
        else if (cur.kind === 'strike') html += wrapStrike(cur.content);
        else if (cur.kind === 'highlight') html += wrapHighlight(cur.content);
        else if (cur.kind === 'sub') html += wrapSub(cur.content);
        i++;
      }
    });
  });

  html += sp(2);
  html += `</div>\n`;
  return html;
}

export function convertHTML(raw: string): string {
  if (!raw.trim()) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString('<div>' + raw + '</div>', 'text/html');
  const container = doc.body.firstChild as Element;
  let html = '';
  html += `<div style="max-width: 780px; margin: 0 auto;">\n`;

  function getStyleAttr(el: Element) { return (el.getAttribute && el.getAttribute('style')) || ''; }
  function getChildStyles(el: Element) {
    let s = '';
    el.querySelectorAll('[style]').forEach(c => s += ' ' + (c.getAttribute('style') || ''));
    return s;
  }

  function getFontSize(el: Element): number {
    const style = getStyleAttr(el);
    const m = style.match(/font-size:\s*([\d.]+)(pt|px)/i);
    if (m) {
      const val = parseFloat(m[1]);
      return m[2] === 'pt' ? val * 1.333 : val;
    }
    const span = el.querySelector('span[style]');
    if (span) {
      const sm = getStyleAttr(span).match(/font-size:\s*([\d.]+)(pt|px)/i);
      if (sm) { const v = parseFloat(sm[1]); return sm[2] === 'pt' ? v * 1.333 : v; }
    }
    const tag = el.tagName;
    if (tag === 'H1') return 32; if (tag === 'H2') return 24;
    if (tag === 'H3') return 19; if (tag === 'H4') return 16;
    if (tag === 'H5') return 13; if (tag === 'H6') return 11;
    return 14;
  }

  function hasBold(el: Element): boolean {
    if (el.querySelector('strong, b')) return true;
    const s = getStyleAttr(el) + ' ' + getChildStyles(el);
    return /font-weight:\s*(bold|[6-9]\d\d)/i.test(s);
  }

  function hasItalic(el: Element): boolean {
    if (el.querySelector('em, i')) return true;
    const s = getStyleAttr(el) + ' ' + getChildStyles(el);
    return /font-style:\s*italic/i.test(s);
  }

  function hasDecoration(el: Element, type: string): boolean {
    const all = getStyleAttr(el) + ' ' + getChildStyles(el);
    return all.includes(type);
  }

  function hasBgColor(el: Element): boolean {
    const all = getStyleAttr(el) + ' ' + getChildStyles(el);
    return /background-color:\s*#(?!fff|FFF|ffffff|FFFFFF)[\da-fA-F]{3,8}/i.test(all);
  }

  function getColor(el: Element): string {
    const all = getStyleAttr(el) + ' ' + getChildStyles(el);
    const m = all.match(/(?<![a-z-])color:\s*(#[\da-fA-F]{3,8})/i);
    return m ? m[1] : '#000000';
  }

  function isGrayColor(c: string) { return /^#(7e8c8d|808080|999|aaa|bbb|ccc|666|777|888|94a3b8|64748b)/i.test(c); }
  function isRedColor(c: string) { return /^#(e03e2d|d21717|ff0000|cc0000|e74c3c|c0392b)/i.test(c); }

  function walk(nodes: Element[]) {
    nodes.forEach(node => {
      if (node.tagName === 'TABLE') {
        const rows: string[][] = [];
        node.querySelectorAll('tr').forEach(tr => {
          const cells = tr.querySelectorAll('td, th');
          if (cells.length >= 2) {
            rows.push([cells[0].textContent!.trim(), cells[1].textContent!.trim()]);
          }
        });
        if (rows.length) { html += sp(1); html += buildTable(rows); html += sp(1); }
        return;
      }

      if (node.tagName === 'IMG') {
        const src = node.getAttribute('src');
        if (src && src !== '' && !src.startsWith('data:')) {
          html += `<p style="text-align: left;"><img src="${esc(src)}"></p>\n`;
          html += sp(1);
        }
        return;
      }

      if (['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI'].includes(node.tagName)) {
        const imgs = node.querySelectorAll('img');
        const text = (node.textContent || '').trim();

        if (imgs.length && !text) {
          imgs.forEach(img => {
            const src = img.getAttribute('src');
            if (src && src !== '' && !src.startsWith('data:')) {
              html += `<p style="text-align: left;"><img src="${esc(src)}"></p>\n`;
              html += sp(1);
            }
          });
          return;
        }

        if (!text || text === '\u00A0') { html += sp(1); return; }

        const computedSize = getFontSize(node);
        const isBoldEl = hasBold(node);
        const isItalicEl = hasItalic(node);
        const hasUnderlineEl = hasDecoration(node, 'underline');
        const hasStrikethroughEl = hasDecoration(node, 'line-through');
        const hasBgHighlightEl = hasBgColor(node);
        const color = getColor(node);

        if (['H1', 'H2'].includes(node.tagName) || computedSize >= 22) {
          html += sp(1);
          const isRed = RED_KEYWORDS.some(k => text.includes(k));
          html += isRed ? wrapHeadingRed(text) : wrapHeading(text);
          html += sp(1);
          imgs.forEach(img => {
            const src = img.getAttribute('src');
            if (src && !src.startsWith('data:')) {
              html += `<p style="text-align: left;"><img src="${esc(src)}"></p>\n`;
              html += sp(1);
            }
          });
          return;
        }

        if (['H3', 'H4'].includes(node.tagName) || (computedSize >= 16 && isBoldEl)) {
          html += sp(1); html += wrapSub(text); html += sp(1); return;
        }

        if (hasStrikethroughEl) { html += wrapStrike(text); return; }
        if (hasBgHighlightEl && isItalicEl) { html += wrapQuote(text); return; }
        if (hasBgHighlightEl) { html += wrapHighlight(text); return; }
        if (hasUnderlineEl && isBoldEl) { html += wrapTextUnderline(text); return; }
        if (computedSize <= 11 || isGrayColor(color)) { html += wrapNote(text); return; }
        if (isRedColor(color) && isBoldEl) { html += wrapAlert(text); return; }
        if (isBoldEl && computedSize >= 14) { html += wrapTextBold(text); return; }
        html += wrapText(text);

        imgs.forEach(img => {
          const src = img.getAttribute('src');
          if (src && !src.startsWith('data:')) {
            html += `<p style="text-align: left;"><img src="${esc(src)}"></p>\n`;
            html += sp(1);
          }
        });
        return;
      }

      if (node.childNodes && node.childNodes.length) {
        walk(Array.from(node.childNodes).filter(n => n.nodeType === 1) as Element[]);
      }
    });
  }

  walk(Array.from(container.children).filter(n => n.nodeType === 1) as Element[]);

  html += sp(2);
  html += `</div>\n`;
  return html;
}

export const SAMPLE_TEXT = `2026 햇 아스파라거스
아삭아삭, 청량하고 싱그러운 맛
제주 그린 아스파라거스 1Kg

"겨울의 에너지를 가득 품은 봄날의 싱그러움
2026 햇 아스파라거스가 수확되는대로 순차 발송됩니다."

연두색 줄기 속에 아삭아삭한 식감과 싱그러운 향을 자랑하는
아스파라거스는 존재만으로도 요리를 근사하게 만들어주죠.
지금까지 드셨던 것을 완전히 잊게 만들어줄
부드럽고 수분 가득한 제주산 아스파라거스를 소개해 드려요.

농장에서 갓 수확하여 보내기 때문에 생으로 먹어도, 익혀 먹어도
풍부한 수분과 청량하고 싱그러운 향이 그대로 느낄 수 있어
다양한 요리에 활용하기 좋아요.
식감, 색감, 영양까지 완벽하여 식탁을 더욱 풍성하게 해줄 거예요.

[이미지]


아삭아삭~ 수분 가득

갓 수확한 아스파라거스 드셔보셨나요.
아스파라거스는 수확한 후 시간이 지날수록 수분이 빠지면서
수확 직후와 수확한 후 시간이 지난 것,
그리고 수입산 아스파라거스의 식감과 맛이 완전히 달라요.
갓 수확한 아스파라거스는 연하고 부드러우면서도
단맛과 수분이 가득해서 한입 무는 순간 아삭아삭~하답니다.

[이미지]

아스파라거스 단면

두꺼운 아스파라거스는 질기다는 편견 No~!
연한 단면 안에 촉촉한 채즙이 가득해서
두꺼울수록 식감을 제대로 느낄 수 있어요.

[이미지]


아스파라거스 굵기

길이는 모두 25cm이고 굵기와 무관하게 모두 연하고 수분 가득해요.
자주 드시는 요리나 취향에 맞게 선택해 주세요.

[이미지]

▶ 1Kg 기준
~~1번 대 : 18개 내외 (1개 50g 이상, 스테이크)~~
==2번 대 : 25개 내외 (1개 40~49g, 스테이크 및 일반 조리용)==
~~3번 중 : 30개 내외 (1개 30~39g, 베이컨 말이 및 일반 조리용)~~
~~4번 중 : 50개 내외 (1개 20~29g, 장아찌 및 볶음요리)~~
~~5번 소 : 60~70개 내외 (1개 10~19g, 어린이용, 장아찌 및 볶음요리)~~


이렇게 드세요

여러분의 식탁을 풍요롭게 해줄 연두색의 채소 아스파라거스는
특별한 요리나 양념을 하지 않아도 담백한 맛과 아삭한 식감을 자랑해요.
살짝 구워서 계란 프라이와 함께 먹거나
샐러드, 안주, 볶음 요리로 드셔도 아주 별미예요.

[이미지]


이렇게 보내드려요

아스파라거스는 농장에서 수확한 후 굵기와 길이 선별만 한 후
1Kg 단위로 한 묶음으로 랩으로 포장하여 보내드려요.
배송 중 신선함이 유지되도록 완충제, 아이스팩과 함께
아이스박스에 넣어서 포장합니다.

[이미지]


배송 안내

산지 직송

갓 수확한 아스파라거스를 산지에서 직접 발송해 드립니다.
- 한진 택배사로 발송됩니다.
- 월~금요일 제주에서 발송하며 영업일 기준 평균 2~3일 이내에 배송됩니다.
- 발송 전날 오후 4시 주문이 마감되니 참고 부탁드립니다.


상품명:제주 그린 아스파라거스
중량/용량:1Kg
상품 구성:아스파라거스 1Kg 랩포장 1묶음
원산지:제주특별자치도 (국내산)
생산자:제주 애월 박경환 농부님
보관 및 취급방법:줄기는 랩으로 감싸고 밑동에 젖은 키친타월, 세워서 냉장보관
배송:한진택배 / 월~금 제주 출발 / 영업일 기준 평균 2~3일 이내
소비자 상담 문의:010-5850-4634`;

// 이미지 최적화 관련
export const COUPANG_MIN_W = 300;
export const COUPANG_MAX_W = 3000;
export const COUPANG_MAX_H = 30000;

export interface ImageSettings {
  maxW: number;
  maxH: number;
  format: string;
  quality: number;
  maxKB: number;
}

export interface ImageItem {
  id: number;
  name: string;
  origWidth: number;
  origHeight: number;
  origSize: number;
  origDataURL: string;
  img: HTMLImageElement;
  result: ImageResult | null;
}

export interface ImageResult {
  dataURL: string;
  width: number;
  height: number;
  size: number;
  quality: number;
  format: string;
  fileName: string;
  isValid: boolean;
  errors: string[];
}

function getDataURLSize(dataURL: string): number {
  const base64 = dataURL.split(',')[1];
  return Math.round(base64.length * 3 / 4);
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1024 / 1024).toFixed(2) + ' MB';
}

export function optimizeImage(item: ImageItem, settings: ImageSettings): ImageResult {
  let w = item.origWidth, h = item.origHeight;

  let targetW = Math.max(COUPANG_MIN_W, Math.min(settings.maxW || 780, COUPANG_MAX_W));

  if (w !== targetW) {
    h = Math.round(h * targetW / w);
    w = targetW;
  }

  if (settings.maxH > 0 && h > settings.maxH) {
    w = Math.round(w * settings.maxH / h);
    h = settings.maxH;
  }

  if (h > COUPANG_MAX_H) {
    w = Math.round(w * COUPANG_MAX_H / h);
    h = COUPANG_MAX_H;
  }

  if (w < COUPANG_MIN_W) { h = Math.round(h * COUPANG_MIN_W / w); w = COUPANG_MIN_W; }
  if (w > COUPANG_MAX_W) { h = Math.round(h * COUPANG_MAX_W / w); w = COUPANG_MAX_W; }

  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d')!;
  ctx.drawImage(item.img, 0, 0, w, h);

  let mime = 'image/jpeg';
  if (settings.format === 'png') mime = 'image/png';
  if (settings.format === 'webp') mime = 'image/webp';

  let quality = settings.quality;
  let dataURL = canvas.toDataURL(mime, quality);

  if (settings.maxKB > 0) {
    let attempts = 0;
    while (getDataURLSize(dataURL) > settings.maxKB * 1024 && quality > 0.1 && attempts < 20) {
      quality -= 0.05;
      dataURL = canvas.toDataURL(mime, quality);
      attempts++;
    }
  }

  const finalSize = getDataURLSize(dataURL);
  const errors: string[] = [];
  if (w < COUPANG_MIN_W) errors.push(`가로 ${w}px < 최소 ${COUPANG_MIN_W}px`);
  if (w > COUPANG_MAX_W) errors.push(`가로 ${w}px > 최대 ${COUPANG_MAX_W}px`);
  if (h > COUPANG_MAX_H) errors.push(`세로 ${h}px > 최대 ${COUPANG_MAX_H}px`);

  const ext = settings.format === 'png' ? '.png' : settings.format === 'webp' ? '.webp' : '.jpg';
  const baseName = item.name.replace(/\.[^.]+$/, '');

  return {
    dataURL,
    width: w,
    height: h,
    size: finalSize,
    quality: Math.round(quality * 100),
    format: settings.format,
    fileName: baseName + '_optimized' + ext,
    isValid: errors.length === 0,
    errors,
  };
}
